import React, { useEffect } from 'react';
import { Link } from 'react-router-dom'
import Header from "../Component/Header";
const JuniorBoard = () => {
    useEffect(() => {
        document.title = 'Junior Board -  The Air Force School Subroto Park';
    }, []);
    return (
        <>
            <Header />
            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>
                    <li>  About Us</li>
                    <li>Prefectorial Board</li>
                    <li>Junior Board</li>
                </ul>
            </div>
            <div className="innersec">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h1> Junior School </h1>
                        </div>
                    </div>
                    <div className="row">

                        {/* <div className="col-lg-12">
                            <h6>Student Council 2024-2025</h6>
                            <div className="table-responsive maintable">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Designation</th>
                                            <th>Name </th>
                                            <th>Class/Sec</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td> HEAD GIRL </td>
                                            <td> Akshita Harikrishnan </td>
                                            <td> VE </td> </tr> <tr> <td> HEAD BOY </td>
                                            <td> Anirudha  Kumar Dubey </td> <td> VC </td>
                                        </tr> <tr> <td> VICE HEAD GIRL </td> <td> Arna Chaudhary </td> <td> VB </td> </tr> <tr> <td> VICE HEAD BOY </td> <td> Aaayan Sharma </td> <td> VA </td> </tr> <tr> <td> SPORTS CAPTAIN (GIRLS) </td> <td> Kanishka Singh </td> <td> VC </td> </tr> <tr> <td> GAMES CAPTAIN (BOYS) </td> <td> Purahan Pillai </td> <td> VB </td> </tr> <tr> <td> VICE SPORTS CAPTAIN (GIRLS) </td> <td> Kashu </td> <td> VA </td> </tr> <tr> <td> VICE SPORTS CAPTAIN (BOYS) </td> <td> Arastu Mishra </td> <td> VB </td> </tr>   <tr> <td> DISCIPLINE PREFECT </td> <td> Navya Sajane </td> <td> VA </td> </tr> <tr> <td> </td> <td> Harshit Dagur </td> <td> VB </td> </tr> <tr> <td> </td> <td> Maisha Gera </td> <td> VC </td> </tr> <tr> <td> </td> <td> Abhijay  Pratap Bhargava </td> <td> VD </td> </tr> <tr> <td> </td> <td> Vihaan Boora </td> <td> VE </td> </tr> <tr> <td> CO-CURRICULAR PREFECT </td> <td> Ravya Singh </td> <td> VA </td> </tr> <tr> <td> </td> <td> Gauri Thakur </td> <td> VB </td> </tr> <tr> <td> </td> <td> Shireen Kaur </td> <td> VC </td> </tr> <tr> <td> </td> <td> Adiva Gautam </td> <td> VD </td> </tr> <tr> <td> </td> <td> Sambhavi Singh </td> <td> VE </td> </tr> <tr> <td> ACADEMIC PREFECT </td> <td> Seerat Adgotra </td> <td> VA </td> </tr> <tr> <td> </td> <td> Aarav Sharma </td> <td> VB </td> </tr> <tr> <td> </td> <td> Simrat Kaur </td> <td> VC </td> </tr> <tr> <td> </td> <td> Naina </td> <td> VD </td> </tr> <tr> <td> </td> <td> NaavyaTomar </td> <td> VE </td> </tr> <tr> <td> LITERARY PREFECT </td> <td> Jaanvi Jain </td> <td> VA </td> </tr> <tr> <td> </td> <td> Ijjurouthu Sai Satvik </td> <td> VB </td> </tr> <tr> <td> </td> <td> Siddhi Kathuria </td> <td> VC </td> </tr> <tr> <td> </td> <td> Samagra Joshi </td> <td> VD </td> </tr> <tr> <td> </td> <td> Anika Bisht </td> <td> VE </td> </tr> <tr> <td> ENVIRONMENTAL PREFECT </td> <td> Jiya Thakur </td> <td> VA </td> </tr> <tr> <td> </td> <td> Upashna </td> <td> VB </td> </tr> <tr> <td> </td> <td> Lavnya Singh </td> <td> VC </td> </tr> <tr> <td> </td> <td> Hargun </td> <td> VD </td> </tr> <tr> <td> </td> <td> Harsh Kumar Ray </td> <td> VE </td> </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div> */}

                        <div class="col-lg-12">
                            <h6>Student Council Junior Wing 2025–2026</h6>
                            <div class="table-responsive maintable">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>Designation</th>
                                            <th>Name</th>
                                            <th>Class/Sec</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr><td>HEAD GIRL</td><td>Navika Hazari</td><td>V A</td></tr>
                                        <tr><td>HEAD BOY</td><td>Zoravar Singh Rana</td><td>V C</td></tr>
                                        <tr><td>VICE HEAD GIRL</td><td>Amishta Bhardwaj</td><td>V E</td></tr>
                                        <tr><td>VICE HEAD BOY</td><td>Prahlad Krishnan Nair</td><td>V F</td></tr>
                                        <tr><td>SPORTS CAPTAIN (GIRLS)</td><td>Veeha Arora</td><td>V B</td></tr>
                                        <tr><td>SPORTS CAPTAIN (BOYS)</td><td>Pratyush Singh</td><td>V B</td></tr>
                                        <tr><td>VICE SPORTS CAPTAIN (GIRLS)</td><td>Shreya Gorai</td><td>V E</td></tr>
                                        <tr><td>VICE SPORTS CAPTAIN (BOYS)</td><td>Ayush</td><td>V A</td></tr>

                                        <tr><td rowspan="5">DISCIPLINE PREFECT</td><td>Aadya Gupta</td><td>V A</td></tr>
                                        <tr><td>Arjun Singh</td><td>V A</td></tr>
                                        <tr><td>Gaurisha Patel</td><td>V A</td></tr>
                                        <tr><td>Nakshat Rana</td><td>V A</td></tr>
                                        <tr><td>Tavishi Prasun</td><td>V A</td></tr>

                                        <tr><td rowspan="5">DISCIPLINE PREFECT</td><td>Sanvi Singh</td><td>V B</td></tr>
                                        <tr><td>Pihu Ahlawat</td><td>V B</td></tr>
                                        <tr><td>Ishika Singh</td><td>V B</td></tr>
                                        <tr><td>Anshika Yadav</td><td>V B</td></tr>
                                        <tr><td>Virat Singh</td><td>V B</td></tr>

                                        <tr><td rowspan="5">DISCIPLINE PREFECT</td><td>Ohana Tyagi</td><td>V C</td></tr>
                                        <tr><td>Bhavishya Dwivedi</td><td>V C</td></tr>
                                        <tr><td>Pruthviraj Kumareshi</td><td>V C</td></tr>
                                        <tr><td>Yogita Rathore</td><td>V C</td></tr>
                                        <tr><td>Shivyaa Mehndiratta</td><td>V C</td></tr>

                                        <tr><td rowspan="5">DISCIPLINE PREFECT</td><td>Arshita Singh</td><td>V D</td></tr>
                                        <tr><td>Ganishka Keshwar</td><td>V D</td></tr>
                                        <tr><td>Jaishnavi Deep</td><td>V D</td></tr>
                                        <tr><td>Prag</td><td>V D</td></tr>
                                        <tr><td>Aayat Zareesh</td><td>V D</td></tr>

                                        <tr><td rowspan="5">DISCIPLINE PREFECT</td><td>Abhigya Sharma</td><td>V E</td></tr>
                                        <tr><td>Palash Shailesh Kulkarni</td><td>V E</td></tr>
                                        <tr><td>Arnav Sharma</td><td>V E</td></tr>
                                        <tr><td>Anvi Ramola</td><td>V E</td></tr>
                                        <tr><td>Jyoti Prakash</td><td>V E</td></tr>

                                        <tr><td rowspan="5">DISCIPLINE PREFECT</td><td>John Felix</td><td>V F</td></tr>
                                        <tr><td>Navneet Chaurasiya</td><td>V F</td></tr>
                                        <tr><td>Aanya Kumari</td><td>V F</td></tr>
                                        <tr><td>Ruhani Balhara</td><td>V F</td></tr>
                                        <tr><td>Dwij Tyagi</td><td>V F</td></tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </>
    )
}

export default JuniorBoard